// Polubienia opinii (serduszka, Figma 2061-661). Brak logowania — stan „polubione" trzymamy
// w localStorage per uuid opinii, a backend tylko inkrementuje/dekrementuje licznik.
// Domyślnie serce jest konturowe; hover podświetla je (CSS), a polubienie wypełnia na stałe.
const STORAGE_PREFIX = 'dove_review_liked_';

function isLiked(uuid) {
    try {
        return window.localStorage.getItem(STORAGE_PREFIX + uuid) === '1';
    } catch (e) {
        return false;
    }
}

function setLiked(uuid, liked) {
    try {
        if (liked) {
            window.localStorage.setItem(STORAGE_PREFIX + uuid, '1');
        } else {
            window.localStorage.removeItem(STORAGE_PREFIX + uuid);
        }
    } catch (e) {
        /* localStorage niedostępne — trudno, stan tylko na czas sesji */
    }
}

function bootLike(button) {
    const uuid = button.dataset.reviewUuid;
    const countEl = button.querySelector('[data-review-like-count]');
    if (!uuid || !countEl) return;

    let liked = isLiked(uuid);
    let busy = false;

    const render = () => {
        button.classList.toggle('is-liked', liked);
        button.setAttribute('aria-pressed', String(liked));
    };
    render();

    button.addEventListener('click', async () => {
        if (busy) return;
        busy = true;

        const nextLiked = !liked;
        const prevCount = parseInt(countEl.textContent, 10) || 0;

        // Optymistycznie: od razu zmieniamy UI i licznik.
        liked = nextLiked;
        setLiked(uuid, nextLiked);
        countEl.textContent = String(Math.max(0, prevCount + (nextLiked ? 1 : -1)));
        render();

        try {
            const res = await fetch(`/api/reviews/${encodeURIComponent(uuid)}/like`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ liked: nextLiked }),
            });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const data = await res.json();
            if (typeof data.likes === 'number') {
                countEl.textContent = String(data.likes);
            }
        } catch (e) {
            // Rollback przy błędzie sieci/serwera.
            liked = !nextLiked;
            setLiked(uuid, liked);
            countEl.textContent = String(prevCount);
            render();
        } finally {
            busy = false;
        }
    });
}

function initReviewLikes() {
    document.querySelectorAll('[data-review-like]').forEach(bootLike);
}

initReviewLikes();
